import { Route } from 'react-router'
import React from 'react'
import App from './app'
import SignUp from './signup'
import LogIn from './login'

// we have to pass the store into this function so we can extract user name from cookies
export default function getRoutes(store) {
  const AppWrapper = (props) => {
    return (
      <App
        userName={store.getState().me.user_name}
        {...props}
      />
    )
  }

  return [
    <Route path='/' component={AppWrapper} />,
    <Route path='/login' getComponent={(location, cb) => {
      import('./login').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/signup' getComponent={(location, cb) => {
      import('./signup').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/recover' getComponent={(location, cb) => {
      import('./recover').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/clipper/*' component={App} />,
    <Route path='/(:view)' component={App} />,
    <Route path='/(:view)/(:shortcode)' component={App} />,
    <Route path='/(:view)/(:shortcode)/(:version)' component={App} />
  ]
}
